import React from "react";
import "../styles/Home.css";

const Home = () => {
    return (
        <div className="bacolor">

            {/* SECTION 1 */}
            <section className="home-wrapper" id="home">
                <div className="home-text" data-aos="fade-up">
                    <h1 className="fs" data-aos="fade-up">TRAIN HARD. STAY
                        STRONG...</h1>
                    <p className="fs1" data-aos="fade-up">Push your limits, break barriers, and transform yourself every single day. Our expert trainers and state-of-the-art equipment are here to guide your journey.</p>
                    <button className="homebtn" data-aos="fade-up">Join Now</button>
                </div>
            </section>

            {/* SECTION 2 */}
            <section className="activities" >
                <h1 className="activitiesh1" data-aos="fade-down">Our Most Advanced  Gym Equiments</h1>
                <p className="activitiesp" data-aos="fade-down">“Train smarter, push harder, and achieve more with our most advanced gym equipment.”</p>
                <div className="activitiessub">
                    <div className="activitiescard" >
                        <img src="/assets/equips/equip1.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>Bench Press</h1>
                            </div>
                        </div>
                        <p>Burn calories, boost stamina, and stay fit</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                    <div className="activitiescard">
                        <img src="/assets/equips/equip2.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>Weight Bar</h1>
                            </div>
                        </div>
                        <p>A Perfect Tool to build strength, tone muscles</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                    <div className="activitiescard" >
                        <img src="/assets/equips/equip3.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>Dumbells</h1>
                            </div>
                        </div>
                        <p>A Perfect Tool to build strength, tone muscles</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                </div>
                <div className="activitiessub">
                    <div className="activitiescard">
                        <img src="/assets/equips/equip4.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>Seated Bench Press</h1>
                            </div>
                        </div>
                        <p>Burn calories, boost stamina, and stay fit anytime</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                    <div className="activitiescard" >
                        <img src="/assets/equips/equip5.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>Cycling</h1>
                            </div>
                        </div>
                        <p>Burn calories, boost stamina, and stay fit anytime</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                    <div className="activitiescard" >
                        <img src="/assets/equips/equip6.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon" data-aos="fade-up">
                            <div className="icontext">
                                <h1>TreadMill</h1>
                            </div>
                        </div>
                        <p>Burn calories, boost stamina, and stay fit anytime</p>
                        <div className="starclass"> <img className="star" src="/assets/equips/star.png" alt="" /> <p> 4.5 Reviews </p> </div>
                        <p><span className="txtdec">$1,999</span>$999</p>
                    </div>
                </div>
            </section>

            {/* SECTION 3 */}
            <section className="activities" id="category" >
                <h1 className="activitiesh1 eventh1" data-aos="fade-down">We have all Category in Our Gym</h1>
                <div className="activitiessub">
                    <div className="activitiescardcat" data-aos="fade-up">
                        <img className="catimg" src="/assets/category/cat1.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon">
                            <div className="icontext">
                                <h1>Tread Mill</h1>
                            </div>
                        </div>
                    </div>
                    <div className="activitiescardcat" data-aos="fade-up">
                        <img className="catimg" src="/assets/category/cat2.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon">
                            <div className="icontext">
                                <h1>DumbBells</h1>
                            </div>
                        </div>
                    </div>
                    <div className="activitiescardcat" data-aos="fade-up">
                        <img className="catimg" src="/assets/category/cat3.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon">
                            <div className="icontext">
                                <h1>BarBell</h1>
                            </div>
                        </div>
                    </div>
                    <div className="activitiescardcat" data-aos="fade-up">
                        <img className="catimg" src="/assets/category/cat4.png" data-aos="zoom-in" alt="" />
                        <div className="activitiesicon">
                            <div className="icontext">
                                <h1>Yoga</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 4 */}
            <section className="events boosted">
                <h1 className="activitiesh1 " data-aos="fade-down">Boost Your Achievements</h1>
                <p className="eventsp" data-aos="fade-down">Your body can stand almost anything. It’s your mind you have to convince.”</p>
                <div className="boost">
                    <div className="boost1" data-aos="fade-up">
                        <img className="boost1img" src="/assets/boost/boost1.png" data-aos="zoom-in" alt="" />
                        <div className="boost2cont">
                            <h2 className="boostconth2">“Balance your body, calm your mind, and strengthen your spirit with every yoga session.”</h2>
                            <p className="boostcontp">“Balance your body, calm your mind, and strengthen your spirit with every yoga session.”</p>
                            <button className="boostbtn">View Details <span className="boostbtnarrow">&#8658;</span></button>
                        </div>
                    </div>
                    <div className="boost2">
                        <div className="boost11" data-aos="fade-up">
                            <img className="boost2img" src="/assets/boost/boost2.png" data-aos="zoom-in" alt="" />
                            <div className="boost1cont">
                                <h2 className="boostconth2">“Push your limits and sculpt your chest with every bench press.  Strength, power, and  results start here.”</h2>
                                <p className="boostcontp">“Balance your body, calm your mind, and strengthen your spirit with every yoga session.”</p>
                                <button className="boostbtn">View Details <span className="boostbtnarrow">&#8658;</span></button>
                            </div>
                        </div>
                        <div className="boost12" data-aos="fade-up">
                            <img className="boost2img" src="/assets/boost/boost3.png" data-aos="zoom-in" alt="" />
                            <div className="boost1cont">
                                <h2 className="boostconth2">“Lift heavy, grow stronger, and conquer every challenge.  Every rep takes you closer to your strongest </h2>
                                <p className="boostcontp">“Balance your body, calm your mind, and strengthen your spirit with every yoga session.”</p>
                                <button className="boostbtn">View Details <span className="boostbtnarrow">&#8658;</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 5 */}
            <section className="plancard" id="Membership">
                <h1 className="activitiesh1" data-aos="fade-down">Choose Your Membership</h1>
                <p className="eventsp" data-aos="fade-down">Flexible Plan to Fit Your Goal Start 14 Days Free Trails</p>
                <div className="cards-container">
                    {/* CARD 1 */}
                    <div className="card color1" data-aos="fade-up">
                        <div className="card-inner">
                            <div className="card-front">
                                <h3 className="plan">Essential Plan</h3>
                                <p className="planp">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <button className="planbtn">View Plan</button>
                            </div>
                            <div className="card-back">
                                <div className="iconpix"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320.1 32C329.1 32 337.4 37.1 341.5 45.1L415 189.3L574.9 214.7C583.8 216.1 591.2 222.4 594 231C596.8 239.6 594.5 249 588.2 255.4L473.7 369.9L499 529.8C500.4 538.7 496.7 547.7 489.4 553C482.1 558.3 472.4 559.1 464.4 555L320.1 481.6L175.8 555C167.8 559.1 158.1 558.3 150.8 553C143.5 547.7 139.8 538.8 141.2 529.8L166.4 369.9L52 255.4C45.6 249 43.4 239.6 46.2 231C49 222.4 56.3 216.1 65.3 214.7L225.2 189.3L298.8 45.1C302.9 37.1 311.2 32 320.2 32zM320.1 108.8L262.3 222C258.8 228.8 252.3 233.6 244.7 234.8L119.2 254.8L209 344.7C214.4 350.1 216.9 357.8 215.7 365.4L195.9 490.9L309.2 433.3C316 429.8 324.1 429.8 331 433.3L444.3 490.9L424.5 365.4C423.3 357.8 425.8 350.1 431.2 344.7L521 254.8L395.5 234.8C387.9 233.6 381.4 228.8 377.9 222L320.1 108.8z" /></svg></div>
                                <h2 className="cbh2">Essential</h2>
                                <p className="cbp1">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <p className="cbp2">$19/Month</p>
                                <ul>
                                    <li>Personalized Beginner Workout Plan</li>
                                    <li>Access to Basic Gym Equipment</li>
                                    <li>Free Fitness Assessment & Body Analysis</li>
                                    <li>One-on-One Trainer Guidance</li>
                                    <li>Introductory Yoga & Cardio Sessions</li>
                                    <li>Nutritional Tips for Beginners</li>
                                    <li>Flexible Workout Timings</li>
                                    <li>Progress Tracking & Monthly Evaluation</li>
                                </ul>
                                <button className="cbtn">Start Plan</button>
                            </div>
                        </div>
                    </div>

                    {/* CARD 2 */}
                    <div className="card color2" data-aos="fade-up">
                        <div className="card-inner">
                            <div className="card-front">
                                <h3 className="plan">Premium Plan</h3>
                                <p className="planp">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <button className="planbtn">View Plan</button>
                            </div>
                            <div className="card-back">
                                <div className="iconpix"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320.1 32C329.1 32 337.4 37.1 341.5 45.1L415 189.3L574.9 214.7C583.8 216.1 591.2 222.4 594 231C596.8 239.6 594.5 249 588.2 255.4L473.7 369.9L499 529.8C500.4 538.7 496.7 547.7 489.4 553C482.1 558.3 472.4 559.1 464.4 555L320.1 481.6L175.8 555C167.8 559.1 158.1 558.3 150.8 553C143.5 547.7 139.8 538.8 141.2 529.8L166.4 369.9L52 255.4C45.6 249 43.4 239.6 46.2 231C49 222.4 56.3 216.1 65.3 214.7L225.2 189.3L298.8 45.1C302.9 37.1 311.2 32 320.2 32zM320.1 108.8L262.3 222C258.8 228.8 252.3 233.6 244.7 234.8L119.2 254.8L209 344.7C214.4 350.1 216.9 357.8 215.7 365.4L195.9 490.9L309.2 433.3C316 429.8 324.1 429.8 331 433.3L444.3 490.9L424.5 365.4C423.3 357.8 425.8 350.1 431.2 344.7L521 254.8L395.5 234.8C387.9 233.6 381.4 228.8 377.9 222L320.1 108.8z" /></svg></div>
                                <h2 className="cbh2">Premium</h2>
                                <p className="cbp1">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <p className="cbp2">$19/Month</p>
                                <ul>
                                    <li>Personalized Beginner Workout Plan</li>
                                    <li>Access to Basic Gym Equipment</li>
                                    <li>Free Fitness Assessment & Body Analysis</li>
                                    <li>One-on-One Trainer Guidance</li>
                                    <li>Introductory Yoga & Cardio Sessions</li>
                                    <li>Nutritional Tips for Beginners</li>
                                    <li>Flexible Workout Timings</li>
                                    <li>Progress Tracking & Monthly Evaluation</li>
                                </ul>
                                <button className="cbtn">Start Plan</button>
                            </div>
                        </div>
                    </div>

                    {/* CARD 3 */}
                    <div className="card color3" data-aos="fade-up">
                        <div className="card-inner">
                            <div className="card-front">
                                <h3 className="plan">Elite Plan</h3>
                                <p className="planp">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <button className="planbtn">View Plan</button>
                            </div>
                            <div className="card-back">
                                <div className="iconpix"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320.1 32C329.1 32 337.4 37.1 341.5 45.1L415 189.3L574.9 214.7C583.8 216.1 591.2 222.4 594 231C596.8 239.6 594.5 249 588.2 255.4L473.7 369.9L499 529.8C500.4 538.7 496.7 547.7 489.4 553C482.1 558.3 472.4 559.1 464.4 555L320.1 481.6L175.8 555C167.8 559.1 158.1 558.3 150.8 553C143.5 547.7 139.8 538.8 141.2 529.8L166.4 369.9L52 255.4C45.6 249 43.4 239.6 46.2 231C49 222.4 56.3 216.1 65.3 214.7L225.2 189.3L298.8 45.1C302.9 37.1 311.2 32 320.2 32zM320.1 108.8L262.3 222C258.8 228.8 252.3 233.6 244.7 234.8L119.2 254.8L209 344.7C214.4 350.1 216.9 357.8 215.7 365.4L195.9 490.9L309.2 433.3C316 429.8 324.1 429.8 331 433.3L444.3 490.9L424.5 365.4C423.3 357.8 425.8 350.1 431.2 344.7L521 254.8L395.5 234.8C387.9 233.6 381.4 228.8 377.9 222L320.1 108.8z" /></svg></div>
                                <h2 className="cbh2">Elite</h2>
                                <p className="cbp1">“Perfect for newcomers — start your fitness journey with guided workouts and steady progress.”</p>
                                <p className="cbp2">$19/Month</p>
                                <ul>
                                    <li>Personalized Beginner Workout Plan</li>
                                    <li>Access to Basic Gym Equipment</li>
                                    <li>Free Fitness Assessment & Body Analysis</li>
                                    <li>One-on-One Trainer Guidance</li>
                                    <li>Introductory Yoga & Cardio Sessions</li>
                                    <li>Nutritional Tips for Beginners</li>
                                    <li>Flexible Workout Timings</li>
                                    <li>Progress Tracking & Monthly Evaluation</li>
                                </ul>
                                <button className="cbtn">Start Plan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 6 */}
            <section className="testimonials">
                <h1 className="activitiesh1 testimonialsh1" data-aos="fade-down">What Our Members Says</h1>
                <p className="eventsp testimonialsp" data-aos="fade-down">From beginners to pros, everyone finds motivation, support, and real transformation here.</p>
                <div className="testimain">
                    <div className="testi" data-aos="fade-up">
                        <div className="testimg"><img src="/assets/testimonials/quote.png" alt="" /></div>
                        <div className="testitext">
                            <div className="testimain1">
                                <div className="testisub">
                                    <div className="testiprof"></div>
                                    <div className="testiname">
                                        <h1>Nora</h1>
                                        <p>Doctor</p>
                                    </div>
                                </div>
                                <img src="/assets/testimonials/star.png" data-aos="zoom-in" alt="" />
                                <p>“The best gym experience I’ve ever had — friendly trainers and top-notch equipment The best gym experience I’ve ever had — friendly trainers and top-notch equipment!”</p>
                            </div>
                        </div>
                    </div>
                    <div className="testi" data-aos="fade-up">
                        <div className="testimg"><img src="/assets/testimonials/quote.png" alt="" /></div>
                        <div className="testitext">
                            <div className="testimain1">
                                <div className="testisub">
                                    <div className="testiprof"></div>
                                    <div className="testiname">
                                        <h1>Hinata</h1>
                                        <p>Doctor</p>
                                    </div>
                                </div>
                                <img src="/assets/testimonials/star.png" data-aos="zoom-in" alt="" />
                                <p>“The best gym experience I’ve ever had — friendly trainers and top-notch equipment The best gym experience I’ve ever had — friendly trainers and top-notch equipment!”</p>
                            </div>
                        </div>
                    </div>
                    <div className="testi" data-aos="fade-up">
                        <div className="testimg"><img src="/assets/testimonials/quote.png" alt="" /></div>
                        <div className="testitext">
                            <div className="testimain1">
                                <div className="testisub">
                                    <div className="testiprof"></div>
                                    <div className="testiname">
                                        <h1>Nic</h1>
                                        <p>Working</p>
                                    </div>
                                </div>
                                <img src="/assets/testimonials/star.png" data-aos="zoom-in" alt="" />
                                <p>“The best gym experience I’ve ever had — friendly trainers and top-notch equipment The best gym experience I’ve ever had — friendly trainers and top-notch equipment!”</p>
                            </div>
                        </div>
                    </div>
                    <div className="testi" data-aos="fade-up">
                        <div className="testimg"><img src="/assets/testimonials/quote.png" data-aos="zoom-in" alt="" /></div>
                        <div className="testitext">
                            <div className="testimain1">
                                <div className="testisub">
                                    <div className="testiprof"></div>
                                    <div className="testiname">
                                        <h1>Eren</h1>
                                        <p>Fighter</p>
                                    </div>
                                </div>
                                <img src="/assets/testimonials/star.png" data-aos="zoom-in" alt="" />
                                <p>“The best gym experience I’ve ever had — friendly trainers and top-notch equipment The best gym experience I’ve ever had — friendly trainers and top-notch equipment!”</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 7 */}
            <section className="events" id="trainers">
                <h1 className="activitiesh1" data-aos="fade-down">Our Gym Top Trainers</h1>
                <p className="activitiesp" data-aos="fade-down">Our certified trainers are here to guide, motivate, and transform your fitness journey.</p>
                <div className="reviewmain" data-aos="fade-up">
                    <div className="reviewcard" data-aos="fade-up">
                        <img className="imgstar" src="/assets/trainer/train1.png" data-aos="zoom-in" alt="" />
                    </div>
                    <div className="reviewcard" data-aos="fade-up">
                        <img className="imgstar" src="/assets/trainer/train2.png" data-aos="zoom-in" alt="" />
                    </div>
                    <div className="reviewcard" data-aos="fade-up">
                        <img className="imgstar" src="/assets/trainer/train3.png" data-aos="zoom-in" alt="" />
                    </div>
                    <div className="reviewcard" data-aos="fade-up">
                        <img className="imgstar" src="/assets/trainer/train4.png" data-aos="zoom-in" alt="" />
                    </div>
                </div>
            </section>

            {/* SECTION 8 */}
            <section className="accordion-wrapper">
                <h1 className="activitiesh1 accord" data-aos="fade-down">Frequently Asked Questions</h1>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary">Do you offer beginner-friendly programs?</summary>
                    <p className="accordion-content">
                        Yes! We have personalized Beginner Plans with trainer guidance to help you start your fitness journey safely.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary"> Is a personal trainer available?</summary>
                    <p className="accordion-content">
                        Absolutely. Our certified trainers provide one-on-one coaching, workout plans, and nutrition guidance.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary"> What types of memberships do you offer?</summary>
                    <p className="accordion-content">
                        We offer Essential, Premium, and Elite membership plans to suit every fitness level and goal.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary"> How can I sign up?</summary>
                    <p className="accordion-content">
                        You can register online through our website or visit us in person to choose a plan and start your fitness journey.
                    </p>
                </details>
            </section>

            <section className="subscription">
                <h1 className="subsh1" data-aos="fade-down">Stay Connected with Fit Belive </h1>
                <p className="subsp" data-aos="fade-down">We’d love to hear from you! Whether you have questions about memberships, classes, or your fitness journey, our team is here to help.</p>
                <div className="subsbut" data-aos="fade-up">
                    <input placeholder="Enter your Mail" className="subsint" type="text" />
                    <button className="subsbtn">Subscribe</button>
                </div>
                <p className="subsp1" data-aos="fade-up">Subscribe to Newsletter</p>
            </section>
        </div>
    );
};

export default Home;
